import React, { useMemo, useState } from 'react';
import { useContractState } from '../context/ContractContext';
import { useWallet } from '../context/WalletContext';
import NFTGrid from '../components/nft/NFTGrid';
import NFTDetailModal from '../components/nft/NFTDetailModal';
import EmptyState from '../components/common/EmptyState';
import { generateNFTs } from '../utils/nftGenerator';
import { APP } from '../config/appConfig';

export default function MyNFTs() {
  const { account } = useWallet();
  const { investments, basic } = useContractState();
  const [selected, setSelected] = useState(null);

  // lastTradeTime bumps every time Start Trade succeeds, so this reshuffles the whole set.
  const shuffleKey = basic ? Number(basic.lastTradeTime || 0) : 0;

  const nfts = useMemo(
    () => generateNFTs(account, investments || [], APP.nftChunkStep, shuffleKey),
    [account, investments, shuffleKey]
  );

  const total = nfts.reduce((a, n) => a + n.value, 0);

  return (
    <div className="page">
      <div className="page-title grad-text">My NFTs</div>
      <p className="page-subtitle">Reshuffle after each Start Trade — new art, new IDs, same holdings.</p>

      <div className="mynft-hero">
        <div className="row-between">
          <div>
            <div className="k">Collection Value</div>
            <div className="v">${total.toLocaleString()}</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div className="k">Items</div>
            <div className="v">{nfts.length}</div>
          </div>
        </div>
      </div>

      {nfts.length === 0
        ? <EmptyState icon="🎨" title="No NFTs yet" msg="Make your first investment to mint your Adrenaline NFTs." />
        : <NFTGrid nfts={nfts} onSelect={setSelected} />}

      <NFTDetailModal nft={selected} onClose={() => setSelected(null)} />
    </div>
  );
}
